export default __webpack_public_path__ + "static/media/boletaTienda.33f6553f.svg";